export const ADULT_DECLARATION_TEXT = 'I confirm that I am 18 years of age or older.';
